import {Component, Input, OnInit} from '@angular/core';
import {CouponApiService} from '../../../core/services/coupon-api.service';
import {ALL_USER_COUPON_URL, Coupon, CouponDistributionConditionType} from '../../../core/model/resources/coupon';
import {Race} from '../../../core/model/resources/race';
import {ActivatedRoute} from '@angular/router';
import {AuthService} from '../../../core/services/auth.service';

@Component({
    selector: 'app-coupon',
    templateUrl: './coupon.component.html',
    styleUrls: ['./coupon.component.scss'],
    standalone: false
})
export class CouponComponent implements OnInit {

  @Input() race?: Race;

  coupons: Coupon[] = [];
  displayedColumns: string[] = ['id', 'title', 'expiredAt', 'term', 'condition'];
  isAllUserCoupon?: boolean;

  constructor(
    private couponApiService: CouponApiService,
    private authService: AuthService,
    private route: ActivatedRoute,
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.isAllUserCoupon = this.route.snapshot.url[0].path === ALL_USER_COUPON_URL;
    await this.fetchCoupons();
  }

  hasAuth(): boolean {
    if (this.isAllUserCoupon) {
      return this.authService.getUserAuth().isAllowManageAllUserCoupon();
    }
    return this.authService.getUserAuth().isAllowManageRaces();
  }

  async fetchCoupons(): Promise<void> {
    let result;

    if (!this.isAllUserCoupon && this.race?.id) {
      result = await this.couponApiService.getList(this.race.id);
    } else {
      result = await this.couponApiService.getList();
    }

    if (result.success) {
      if (result.data !== undefined) {
        this.coupons = result.data.sort((a: Coupon, b: Coupon) => b.id - a.id);
      }
    } else {
      this.coupons = [];
    }
  }

  getCondition(coupon: Coupon): string {
    switch (coupon.distribution_condition_type) {
      case CouponDistributionConditionType.distance:
        return `距離: ${coupon.distribution_condition_value}km以上`;
      case CouponDistributionConditionType.time:
        return `タイム: ${coupon.distribution_condition_value}秒以上`;
      case CouponDistributionConditionType.groupDistance:
        return `グループ平均/合計距離: ${coupon.distribution_condition_value}km以上`;
      case CouponDistributionConditionType.area:
        return `面積: ${coupon.distribution_condition_value}㎡以上`;
      case CouponDistributionConditionType.calorie:
        return `消費カロリー: ${coupon.distribution_condition_value}kcal以上`;
      case CouponDistributionConditionType.activityDays:
        return `達成日数: ${coupon.distribution_condition_value}日以上`;
      case CouponDistributionConditionType.specifiedArea:
        return '指定エリア到達時';
    }
  }

}
